import { createSlice } from '@reduxjs/toolkit'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import { initialState, listReducers } from './listConstants'

dayjs.extend(utc)
dayjs.extend(timezone)
const meetingsState = {
    filters: {
        status: ['Scheduled'],
        startTime: { $gte: dayjs().utc().set('hour', 0).set('minute', 0).set('second', 0).format() }
    },
    pureFilters: {
        status: ['Scheduled'],
        meetingDate: [dayjs(), null],
        timeShift: ''
    },
    preLoading: true,
    sort: { startTime: 1, _id: -1 }
}

const companyMeetingsSlice = createSlice({
    name: 'ui/company-meetings',
    initialState: { ...initialState, ...meetingsState },
    reducers: {
        ...listReducers,
        onChangePreLoading(state, action) {
            state.preLoading = action.payload
        }
    }
})

export const companyMeetingsActions = companyMeetingsSlice.actions
export default companyMeetingsSlice.reducer
